import React from 'react';
import { Dimensions, Image, Text, View } from 'react-native';
import { useLocation } from 'react-router-dom';
import Header from '../../common/Header';
import { getEncKey, forceLogin } from '../../api/apiManager';
import { Encryption as encrypt, decrypt } from '../../utilities/Encryption';
import AsyncStorageFunc from '../../utilities/asyncStorage';
import * as RootNavigation from '../../utilities/RootNavigation';
import { useLogin } from '../../context/loginProvider';
import CImage from '../../common/CImage';
import CustomButton from '../../common/CustomButton';
import applicationStyles from '../../styles/applicationStyles';
import LoginTabIcons from './LoginTabIcons';
import LoginRightWidget from './LoginRightWidget';
import LoginMoibleContent from './LoginMobileContent';
import LoginFooter from './LoginFooter';
import useStyles from './ResponseScreen_Styles';
import CView from '../../styles/CommonStyle';
import { COLORS } from '../../constant';
const isSmallDevice = Dimensions.get('window').width < 767;

export default function ResponseScreen(props) {
  const { state } = useLocation();
  console.log(state, 'params data');
  const data = state?.routeObj || state?.data;
  const title = data?.title;
  const reqId = data?.reqId;
  const mobile = data?.mobile;
  const type = data?.type;
  const msg = data?.msg;
  const btnText = data?.btnText;
  const navigation = data?.navigation;
  const isForceLogin = data?.isForceLogin;
  const userId = data?.username;
  const password = data?.password;
  const loginType = data?.loginType;
  const keepMeSignIn = data?.keepMeSignIn;
  const vrn = state?.vrnFromLogin;
  const { isLoggedIn, setIsLoggedIn } = useLogin();
  const styles = useStyles();
  const headers = { 'keepMeSignIn': keepMeSignIn }; // Passing headers dynamically


  const OnForceLogin = () => {
    getEncKey()
      .then(async (res) => {
        if (res.statusCode == 200) {
          const encKey = res?.data || '';
          const encryptedId = await encrypt(userId, encKey);
          const encryptedPassword = await encrypt(password, encKey);
          const encryptedvrn = await encrypt(vrn, encKey);
          let reqObj = {
            username: encryptedId,
            password: encryptedPassword,
            type: global.loginTYpe === 'LoginByVRN' ? 'otpLogin' : 'passwordLogin',
            useCase: '',
            keepMeSignIn: keepMeSignIn,
          };
          if (password == '') {
            reqObj = { ...reqObj, password: '', type: 'loginByOTP', useCase: '' };
          }
          if (global.loginTYpe == 'otpLogin') {
            reqObj = { ...reqObj, password: '', type: 'loginByOTP', useCase: '' };
          }
          if (loginType === 'LoginByVRN') {
            reqObj = { ...reqObj, password: '', type: 'otpLogin', username: encryptedvrn, useCase: 'LoginByVRN' };
          }

          forceLogin(reqObj,headers)
            .then(async (res) => {
              if (res?.status == 200) {
                if (res?.data?.access_token) {
                  const loginData = await decrypt(res?.data?.access_token);
                  AsyncStorageFunc.storeData('TOKEN', res?.data?.access_token);
                  global.token = res?.data?.access_token;
                  global.userId = loginData.userId;
                  global.userCd = loginData.userCd;
                  global.fullName = loginData.fullName ? loginData.fullName : '';
                  global.userType = loginData.userType;
                  setIsLoggedIn(true);
                  let route = global?.prevRoute || '/Home';
                  route = route.slice(1);
                  RootNavigation.navigate(route, { showConfig: 'showConfig' });
                  global.activeScreen = route;
                  global.showConfig = true;
                }
              }
            })
            .catch((err) => {
              const errData = err?.response?.data;
              let isForceLogin = false;
              let route = global?.prevRoute || '/Home';
              route = route.slice(1);
              if (errData?.message == 'You are already logged in to another device. Do you want to continue here') isForceLogin = true;
              const routeObj = {
                username: userId,
                password: password,
                loginType: global.loginTYpe === 'LoginByVRN' ? 'LoginByVRN' : 'passwordLogin',
                title: 'Login',
                type: 'Error',
                msg: errData?.message,
                btnText: isForceLogin ? 'Continue' : 'Back To Login',
                navigation: isForceLogin ? route : 'Login',
                isForceLogin: isForceLogin,
              };
              RootNavigation.navigate('ResponseScreen', { data: routeObj });
            });
        }
      })
      .catch((err) => {});
  };
  const onSubmit = () => {
    if (isForceLogin) {
      OnForceLogin();
    } else {
      RootNavigation.navigate(navigation, { resError: msg, reqId: reqId, mobile: mobile });
    }
  };

  const renderResponseScreen = () => {
    return (
      <View style={styles.containerBox}>
        <View style={styles.rectangle41}>
          <CImage.BackIconWhite></CImage.BackIconWhite>
          <Text style={[applicationStyles.loginTextStyle]}>{title}</Text>
        </View>
        {}
        <View style={{ width: '100%' }}>
          <View style={styles.cntWidget}>
            <Text style={styles.sucMessage}>{type == 'success' ? 'Successful' : 'Error'}</Text>
            <Image
              source={type == 'success' ? require('../../assets/images/Success.png') : require('../../assets/images/error.png')}
              style={{ height: 30, width: 30, resizeMode: 'center', marginTop: 30 }}
            />
            <Text style={styles.resMessage}>{msg}</Text>
            <View
              style={{
                marginTop: 20,
                width: btnText == 'Change Password' ? 150 : 118,
                height: 37,
              }}>
              <CustomButton
                onPress={onSubmit}
                text={btnText ? btnText : 'Back to Login'}
              />
            </View>
          </View>
        </View>
      </View>
    );
  };

  return (
    <CView style={styles.mainContainerStyle}>
      <CView flex={1}>
        <Header text={'Login'} />
        <View style={styles.bodyContainerStyle}>
          <View style={styles.bodyLeftViewStyle}>
            {renderResponseScreen()}
            <LoginTabIcons />
          </View>
          <LoginRightWidget />
        </View>
        <View style={styles.mobileComponentStyle}>
          <View style={styles.logoWidget}>
            <CView FR>
              <CImage.IDFCLogo></CImage.IDFCLogo>
            </CView>
            <View>
              <CImage.FFLogoSmall></CImage.FFLogoSmall>
            </View>
          </View>
          <View style={styles.widgetCenter}>{renderResponseScreen()}</View>

          <LoginMoibleContent />
        </View>

        <LoginFooter />
      </CView>
    </CView>
  );
}
